module.exports = __webpack_public_path__ + "static/media/chevron-left.78f49ba7.svg";